/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { HonorarioFlutuante } from '../models/honorario-flutuante';
import { PerfilSelecionadoAlcadaAuto } from '../models/perfil-selecionado-alcada-auto';
import { PerfilSelecionadoAlcadaFiancaLocaticia } from '../models/perfil-selecionado-alcada-fianca-locaticia';

/**
 * API para integracao com ODM
 */
@Injectable({
  providedIn: 'root',
})
class ODMService extends __BaseService {
  static readonly obterPercentualHonorarioFlutuantePath = '/odm/honorario-flutuante';
  static readonly executarAlcadaAutoPath = '/odm/alcada/auto';
  static readonly executarAlcadaFiancaPath = '/odm/alcada/fianca';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera todos os registros do enum de forma de pagamento
   * @param params The `ODMService.ObterPercentualHonorarioFlutuanteParams` containing the following parameters:
   *
   * - `perfil`: Perfil operacional da aplicacao utilizado na geracao do acordo
   *
   * - `numeroParcelas`: Quantidade de Parcelas do Acordo
   *
   * - `descontoConcedido`: Percentual do desconto concedido
   *
   * - `anoSinistro`: Ano da ocorrencia do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterPercentualHonorarioFlutuanteResponse(params: ODMService.ObterPercentualHonorarioFlutuanteParams): __Observable<__StrictHttpResponse<HonorarioFlutuante>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.perfil != null) __params = __params.set('perfil', params.perfil.toString());
    if (params.numeroParcelas != null) __params = __params.set('numeroParcelas', params.numeroParcelas.toString());
    if (params.descontoConcedido != null) __params = __params.set('descontoConcedido', params.descontoConcedido.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/odm/honorario-flutuante`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<HonorarioFlutuante>;
      })
    );
  }
  /**
   * Recupera todos os registros do enum de forma de pagamento
   * @param params The `ODMService.ObterPercentualHonorarioFlutuanteParams` containing the following parameters:
   *
   * - `perfil`: Perfil operacional da aplicacao utilizado na geracao do acordo
   *
   * - `numeroParcelas`: Quantidade de Parcelas do Acordo
   *
   * - `descontoConcedido`: Percentual do desconto concedido
   *
   * - `anoSinistro`: Ano da ocorrencia do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterPercentualHonorarioFlutuante(params: ODMService.ObterPercentualHonorarioFlutuanteParams): __Observable<HonorarioFlutuante> {
    return this.obterPercentualHonorarioFlutuanteResponse(params).pipe(
      __map(_r => _r.body as HonorarioFlutuante)
    );
  }

  /**
   * Executa processo de alcada para o auto
   * @param params The `ODMService.ExecutarAlcadaAutoParams` containing the following parameters:
   *
   * - `tipoPessoa`: Tipo de pessoa (Fisica/Juridica)
   *
   * - `score`: Score total do devedor
   *
   * - `ramo`: Ramo do sinistro
   *
   * - `perfil`: Perfil operacional da aplicacao utilizado na geracao do acordo
   *
   * - `parcela`: Quantidade de parcelas do acordo
   *
   * - `origem`: Origem da requisicao
   *
   * - `dinamica`: Dinamica do evento/ocorrencia
   *
   * - `descontoConcedido`: Percentual do desconto concedido
   *
   * - `anoSinistro`: Ano da ocorrencia do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  executarAlcadaAutoResponse(params: ODMService.ExecutarAlcadaAutoParams): __Observable<__StrictHttpResponse<PerfilSelecionadoAlcadaAuto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.tipoPessoa != null) __params = __params.set('tipoPessoa', params.tipoPessoa.toString());
    if (params.score != null) __params = __params.set('score', params.score.toString());
    if (params.ramo != null) __params = __params.set('ramo', params.ramo.toString());
    if (params.perfil != null) __params = __params.set('perfil', params.perfil.toString());
    if (params.parcela != null) __params = __params.set('parcela', params.parcela.toString());
    if (params.origem != null) __params = __params.set('origem', params.origem.toString());
    if (params.dinamica != null) __params = __params.set('dinamica', params.dinamica.toString());
    if (params.descontoConcedido != null) __params = __params.set('descontoConcedido', params.descontoConcedido.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/odm/alcada/auto`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PerfilSelecionadoAlcadaAuto>;
      })
    );
  }
  /**
   * Executa processo de alcada para o auto
   * @param params The `ODMService.ExecutarAlcadaAutoParams` containing the following parameters:
   *
   * - `tipoPessoa`: Tipo de pessoa (Fisica/Juridica)
   *
   * - `score`: Score total do devedor
   *
   * - `ramo`: Ramo do sinistro
   *
   * - `perfil`: Perfil operacional da aplicacao utilizado na geracao do acordo
   *
   * - `parcela`: Quantidade de parcelas do acordo
   *
   * - `origem`: Origem da requisicao
   *
   * - `dinamica`: Dinamica do evento/ocorrencia
   *
   * - `descontoConcedido`: Percentual do desconto concedido
   *
   * - `anoSinistro`: Ano da ocorrencia do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  executarAlcadaAuto(params: ODMService.ExecutarAlcadaAutoParams): __Observable<PerfilSelecionadoAlcadaAuto> {
    return this.executarAlcadaAutoResponse(params).pipe(
      __map(_r => _r.body as PerfilSelecionadoAlcadaAuto)
    );
  }

  /**
   * Executa processo de alcada para o fianca
   * @param params The `ODMService.ExecutarAlcadaFiancaParams` containing the following parameters:
   *
   * - `perfil`: Perfil operacional da aplicacao utilizado na geracao do acordo
   *
   * - `numeroParcelas`: Quantidade de parcelas do acordo
   *
   * - `descontoConcedido`: Percentual do desconto concedido
   *
   * - `anoSinistro`: Ano da ocorrencia do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  executarAlcadaFiancaResponse(params: ODMService.ExecutarAlcadaFiancaParams): __Observable<__StrictHttpResponse<PerfilSelecionadoAlcadaFiancaLocaticia>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.perfil != null) __params = __params.set('perfil', params.perfil.toString());
    if (params.numeroParcelas != null) __params = __params.set('numeroParcelas', params.numeroParcelas.toString());
    if (params.descontoConcedido != null) __params = __params.set('descontoConcedido', params.descontoConcedido.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/odm/alcada/fianca`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PerfilSelecionadoAlcadaFiancaLocaticia>;
      })
    );
  }
  /**
   * Executa processo de alcada para o fianca
   * @param params The `ODMService.ExecutarAlcadaFiancaParams` containing the following parameters:
   *
   * - `perfil`: Perfil operacional da aplicacao utilizado na geracao do acordo
   *
   * - `numeroParcelas`: Quantidade de parcelas do acordo
   *
   * - `descontoConcedido`: Percentual do desconto concedido
   *
   * - `anoSinistro`: Ano da ocorrencia do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  executarAlcadaFianca(params: ODMService.ExecutarAlcadaFiancaParams): __Observable<PerfilSelecionadoAlcadaFiancaLocaticia> {
    return this.executarAlcadaFiancaResponse(params).pipe(
      __map(_r => _r.body as PerfilSelecionadoAlcadaFiancaLocaticia)
    );
  }
}

module ODMService {

  /**
   * Parameters for obterPercentualHonorarioFlutuante
   */
  export interface ObterPercentualHonorarioFlutuanteParams {

    /**
     * Perfil operacional da aplicacao utilizado na geracao do acordo
     */
    perfil: string;

    /**
     * Quantidade de Parcelas do Acordo
     */
    numeroParcelas: number;

    /**
     * Percentual do desconto concedido
     */
    descontoConcedido: string;

    /**
     * Ano da ocorrencia do sinistro
     */
    anoSinistro: number;
  }

  /**
   * Parameters for executarAlcadaAuto
   */
  export interface ExecutarAlcadaAutoParams {

    /**
     * Tipo de pessoa (Fisica/Juridica)
     */
    tipoPessoa: string;

    /**
     * Score total do devedor
     */
    score: number;

    /**
     * Ramo do sinistro
     */
    ramo: number;

    /**
     * Perfil operacional da aplicacao utilizado na geracao do acordo
     */
    perfil: string;

    /**
     * Quantidade de parcelas do acordo
     */
    parcela: number;

    /**
     * Origem da requisicao
     */
    origem: number;

    /**
     * Dinamica do evento/ocorrencia
     */
    dinamica: string;

    /**
     * Percentual do desconto concedido
     */
    descontoConcedido: number;

    /**
     * Ano da ocorrencia do sinistro
     */
    anoSinistro: number;
  }

  /**
   * Parameters for executarAlcadaFianca
   */
  export interface ExecutarAlcadaFiancaParams {

    /**
     * Perfil operacional da aplicacao utilizado na geracao do acordo
     */
    perfil: string;

    /**
     * Quantidade de parcelas do acordo
     */
    numeroParcelas: number;

    /**
     * Percentual do desconto concedido
     */
    descontoConcedido: number;

    /**
     * Ano da ocorrencia do sinistro
     */
    anoSinistro: number;
  }
}

export { ODMService }
